import { TopoNode } from "../Topology/TopoNode";
import { HashSet } from "../Utils/HashSet";
import { DeviceKey, IfKey, KeyNames, KeyPair } from "../Core/Keys";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { TopoImageKey, TopoImageMap } from "../Topology/TopoImageMap";
import { Link } from "../Core/Link";
import { DeviceCategory } from "../Core/DeviceCategory";
import { TopoImageLibrary } from "../Topology/TopoImageLibrary";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";


export enum MultiNodeType { Hub, WirelessClient, VirtualPortGroup };

//export interface MultiLinkDevicesEntryJson {
//    device_key: DeviceKeyJson;
//}

//export interface MultiNodeJson extends TopoNodeJson {
//    topo_image_key: TopoImageKeyJson;
//    description: string;
//    "type": string;
//    multi_link_devices: MultiLinkDevicesEntryJson[];
//}

export class MultiNodeKey {
	private _deviceKeys: HashSet<DeviceKey>;

	constructor(keys: HashSet<DeviceKey>  = new HashSet<DeviceKey>()) {
		this._deviceKeys = keys;
	}

	public get Keys(): HashSet<DeviceKey>{
		return this._deviceKeys;
	}

	public Add(key: DeviceKey): void {
		this._deviceKeys.Add(key);
	}

	public Remove(key: DeviceKey): void {
		this._deviceKeys.Remove(key);
	}

	public Clear(): void {
		this._deviceKeys.Clear();
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return null;

		if (this == obj)
			return true;

		if (!(obj instanceof MultiNodeKey))
			return false;

		var other = <MultiNodeKey> obj;

		return ObjUtils.Equals(this._deviceKeys, other._deviceKeys);
	}

	public GetHashCode(): number {
		var result = 0;

		this._deviceKeys.ForEach((key) => {
			result ^= key.GetHashCode();
		});

		return result;
	}
}

export class MultiNode extends TopoNode {
	private _key: MultiNodeKey;
	private _imageKey: TopoImageKey;
	private _link: Link;

	constructor(link: Link = null, nodeType: MultiNodeType = MultiNodeType.Hub)	{
		super();
		this.Type = nodeType;
		this._key = new MultiNodeKey();
		this.Link = link;
		this._imageKey = new TopoImageKey();
		if (nodeType == MultiNodeType.WirelessClient) {
			this.Description = "Wireless SSID";
			this._imageKey.Add(new KeyPair("dvcat", DeviceCategory.WirelessClient.Name));
		}
        else if (nodeType == MultiNodeType.VirtualPortGroup) {
            this.Description = "Virtual Port Group";
            this._imageKey.Add(new KeyPair("dvcat", DeviceCategory.VirtualPortGroup.Name));
        }
		else {
			this.Description = "Unmanaged Device";
			this._imageKey.Add(new KeyPair("dvcat", DeviceCategory.NetworkDevice.Name));
		}
		this.SetSize();
	}

	public get Key(): MultiNodeKey {
		return this._key;
	}

	public Type: MultiNodeType;

	public GetKey(): MultiNodeKey {
		return this.Key;
	}

	public get Link(): Link {
		return this._link;
	}

	public set Link(value: Link) {
		this._link = value;

		if (this._link != null) {
			this._key.Clear();

			this._link.LinkMembers.ForEach((linkMember) => {
				if (linkMember.HasDevice)
					this._key.Add(linkMember.Device.CreateKey());
			});
		}
	}

	public get HasLink(): boolean {
		return !!this.Link;
	}

	public Description: string;

	public Resolve(node: TopoNode) { 
		if (node instanceof MultiNode) {
			var otherNode = <MultiNode> node;
			if (otherNode != null) {
				this._link = otherNode._link;
				this._key = otherNode._key;
				this.Description = otherNode.Description;
				this.Type = otherNode.Type;
			}
		}
	}

	public UnResolve():void {
		this._link = null;
	}

	public get Image(): HTMLImageElement{
		var result = TopoImageLibrary.FindImage(this._imageKey);
		if (result == null)
			result = new Image(48, 48);
		return result;
	}

	public get DisplayName(): string {
		return "Unmanaged Device";
	}

	private SetSize():void {
		var image :HTMLImageElement = this.Image;
		if (image != null) {
			this.Width = image.width;
			this.Height = image.height;
		}
    }

    //public static FromJson(json: MultiNodeJson): MultiNode {
    //    var result = new MultiNode();

    //    result.CopyTopoNodeJson(json);

    //    if (json.topo_image_key !== undefined)
    //        result._imageKey = TopoImageKey.FromJson(json.topo_image_key);

    //    if (json.description !== undefined)
    //        result.Description = json.description;

    //    if (json.type !== undefined)
    //        result.Type = MultiNodeType[json.type];

    //    if (json.multi_link_devices !== undefined) {
    //        json.multi_link_devices.forEach((value, index, array) => {
    //            result._key.Add(DeviceKey.FromJson(value.device_key));
    //        });
    //    }

    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.hub_node = {};
		obj = obj.hub_node;

		super.Write(obj, context);

		if (!!this._imageKey)
			this._imageKey.Write(obj, "topo_image_key", context);

		obj.description = this.Description;

		obj.type = MultiNodeType[this.Type];

		obj.multi_link_devices = [];
		ObjSerUtils.WriteObjSerCollection(obj.multi_link_devices, this._key.Keys, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.hub_node)
			throw new Error();
		obj = obj.hub_node;

		super.Read(obj, context);

		if (obj.topo_image_key !== undefined) {
			this._imageKey = new TopoImageKey();
			this._imageKey.Read(obj, "topo_image_key", context);
		}
		if (obj.description !== undefined) {
			this.Description = obj.description;
		}
		if (obj.type !== undefined) {
			this.Type = <MultiNodeType>MultiNodeType[<string>obj.type];
		}
		if (obj.multi_link_devices !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.multi_link_devices, this._key.Keys, (value: any) => {
				return new DeviceKey();
			}, context);
		}
	}

}
